import axios from "axios";
import { Message, Loading } from "element-ui";

/* ------------ loading 相关 ------- */
let loadingInstance = null;
let requestCount = 0;

const showLoading = () => {
  if (requestCount === 0) {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: "加载中...",
      background: "rgba(0, 0, 0, 0.7)",
    });
  }
  requestCount++;
};

const hideLoading = () => {
  requestCount--;
  if (requestCount <= 0) {
    loadingInstance?.close();
    requestCount = 0;
  }
};
/* ------------ loading 相关结束 ------- */

const getBaseURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "/api/v1/admin/";
  }
// return "http://www.yangzhifuwu.top/api/v1/admin/";
return "http://localhost:8080/api/v1/admin/";
};

// 创建axios实例
const service = axios.create({
  baseURL: getBaseURL(),
  timeout: 30 * 1000,
  withCredentials: process.env.NODE_ENV === "production",
});

// 密码验证管理器（极简版）
class PasswordVerifyManager {
  constructor() {
    this.instance = null;
  }

  async showVerify() {
    if (!this.instance) {
      const PasswordVerifyComponent = await import(
        "@/components/PasswordVerify/PasswordVerify.vue"
      );
      const Vue = (await import("vue")).default;
      const PasswordVerifyConstructor = Vue.extend(
        PasswordVerifyComponent.default
      );

      this.instance = new PasswordVerifyConstructor();
      this.instance.$mount();
      document.body.appendChild(this.instance.$el);
    }

    return this.instance.show();
  }
}

const verifyManager = new PasswordVerifyManager();

// 请求拦截器 - 极简版
service.interceptors.request.use(
  async (config) => {
    showLoading();

    // 设置请求头
    const accessToken = sessionStorage.getItem("access-token");
    const csrfToken = sessionStorage.getItem("csrf-token");

    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
    };

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    if (csrfToken) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }

    // 跳过登录等不需要验证的接口
    const skipUrls = [
      "/adminLogin",
      "/adminLogout",
      "/adminChangePassword",
      "/resetAdminPassword",
      "/getOperationVerifyConfig",
      "/refreshToken",
      "/captcha",
      "/ulogin",
      "/clogin",
      "/register",
      "/sendAdminVerifyCode",
      "/checkOperationPassword",
      "/setOperationPassword",
    ];

    if (skipUrls.some((url) => config.url.includes(url))) {
      return config;
    }

    // GET请求不需要验证
    if (config.method.toLowerCase() === "get") {
      return config;
    }

    try {
      // 获取验证配置
      const verifyAxios = axios.create({
        baseURL: getBaseURL(),
        timeout: 5000,
      });

      const verifyResponse = await verifyAxios.get(
        "/getOperationVerifyConfig",
        {
          params: {
            path: config.url,
            method: config.method,
          },
        }
      );

      const verifyConfig = verifyResponse.data.data;

      console.log("验证配置:", verifyConfig);

      // 如果不需要验证，直接返回
      if (!verifyConfig.enabled || !verifyConfig.needPasswordVerify) {
        return config;
      }

      // 需要验证，弹出密码框
      const result = await verifyManager.showVerify();

      if (result.verified && result.password) {
        // 添加操作密码到请求
        if (config.data) {
          if (typeof config.data === "string") {
            const dataObj = JSON.parse(config.data);
            dataObj.operationPassword = result.password;  // ← 改这里
            config.data = JSON.stringify(dataObj);
          } else {
            config.data = {
              ...config.data,
              operationPassword: result.password,  // ← 改这里
            };
          }
        } else {
          config.data = { operationPassword: result.password };  // ← 改这里
        }
      } else {
        hideLoading();
        throw new Error("用户取消验证");
      }

      return config;
    } catch (error) {
      hideLoading();

      if (error.message === "用户取消验证") {
        Message.warning("操作已取消");
      } else {
        console.error("验证失败:", error);
      }

      return Promise.reject(error);
    }
  },
  (error) => {
    hideLoading();
    console.error("请求拦截器错误:", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    hideLoading();

    const data = response.data;

    if (
      data.success &&
      data.message &&
      response.config.method.toLowerCase() !== "get"
    ) {
      Message.success(data.message);
    }

    return data;
  },
  (error) => {
    hideLoading();

    if (error.response?.status === 401) {
      const msg = error.response.data?.message || "认证失败";
      if (msg.includes("操作密码")) {
        Message.error("操作密码错误");
      } else {
        Message.error(msg);
      }
    } else if (error.response?.status === 403) {
      Message.error("权限不足");
    } else if (!error.response) {
      if (error.message !== "用户取消验证") {
        Message.error(error.message || "请求失败");
      }
    } else {
      Message.error(error.response.data?.message || "请求失败");
    }

    return Promise.reject(error);
  }
);

export default service;